(function () {
    'use strict';

    angular
        .module('app.campaignViewContract')
        .controller('campaignViewContractCtrl', ['$scope', '$rootScope', '$sce', '$sanitize', '$modal', '$modalInstance', 'campaignViewContractService', 'campaignConsts', 'viewCampaignInfoService', '$modalStack',
            function ($scope, $rootScope, $sce, $sanitize, $modal, $modalInstance, campaignViewContractService, campaignConsts, viewCampaignInfoService, $modalStack) {
                $scope.campaignTypeConsts = angular.copy(campaignConsts.Types);

                // Get params from parent
                $scope.campaignId = angular.copy($scope.paramsFromParent.campaignId);
                $scope.influencerId = angular.copy($scope.paramsFromParent.influencerId);
                $scope.campaignInfluencerId = angular.copy($scope.paramsFromParent.campaignInfluencerId);
                $scope.afterReviewCampaignAccepted = angular.copy($scope.paramsFromParent.afterReviewCampaignAccepted);

                init();

                ////////////////

                function init() {
                    getCampaign();
                    getInfluencer();
                    getContractTermsForInfluencer();
                }

                function getCampaign() {
                    campaignViewContractService.getCampaign($scope.campaignId, true).then(function (result) {
                        var campaign = result.data;
                        $scope.campaignName = campaign.name;
                        $scope.campaignBrief = campaign.brief;
                        var campaignSavedAt = campaign.modifiedAt || campaign.createdAt;
                        $scope.contractDate = moment(campaignSavedAt).format('DD MMM YYYY');

                        $scope.campaignType = $rootScope.definitions.campaignTypes.filter(function(type) {
                            return type.value === campaign.projectType;
                        })[0];

                        getAdvertiser(campaign.company_id);
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                function getAdvertiser(advertiserId) {
                    campaignViewContractService.getAdvertiser(advertiserId, false).then(function (result) {
                        $scope.advertiserName = result.data.name;
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                function getInfluencer() {
                    campaignViewContractService.getInfluencer($scope.influencerId, false).then(function (result) {
                        $scope.influencerName = result.data.name;
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                function getContractTermsForInfluencer() {
                    campaignViewContractService.getContractTermsForInfluencer($scope.campaignId, $scope.campaignInfluencerId, false).then(function (result) {
                        var terms = result.data;

                        $scope.terms = terms.map(function (term) {
                            if (term.params !== undefined) {
                                term.params = JSON.parse(term.params);
                            }

                            term.bodyDisplay = parseTermParamValue(term);

                            return term;
                        }).sort(function(termA, termB) {
                            return termA.contractSeq < termB.contractSeq ? -1 : (termA.contractSeq > termB.contractSeq ? 1 : 0);
                        });
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                function parseTermParamValue (term) {
                    var paramsIsObject = term.params !== null && typeof term.params === 'object'
                    if (!term.hasParams || !paramsIsObject) {
                        return $sce.trustAsHtml(term.body);
                    } else {
                        var display = term.body;

                        Object.keys(term.params).forEach(function(paramName) {
                            display = display.replace(new RegExp('{{' + paramName + '}}', 'g'), $sanitize(term.params[paramName].value));
                        });

                        return $sce.trustAsHtml(display);
                    }
                }

                $scope.acceptCampaignAtCampaignInfo = function(campaign_id, campaignInfluencerId) {
                    var params = {
                        campaignInfluencerId: $scope.campaignInfluencerId,
                    }

                    viewCampaignInfoService.acceptCampaign(params, true).then(function (result) {
                        if (angular.isFunction($scope.afterReviewCampaignAccepted)) {
                            $scope.afterReviewCampaignAccepted();
                        }

                        $modalStack.dismissAll();
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                /**
                 * Cancel and Close buttons
                 */
                $scope.closeModalContractInfo = function () {
                    $modalInstance.close();
                }
            }
        ]);
})();
